import { Component, ElementRef, Input, AfterViewInit } from '@angular/core';

@Component({
  selector: 'smrts-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false
})

export class DialogComponent implements AfterViewInit {

  @Input() title: string = '';
  @Input() hasFootnote: boolean = false;
  @Input() useDefaultHeader: boolean = true;
  @Input() useContentPadding: boolean = true;
  @Input() fixedHeight: string | null = null;
  @Input() footnoteBackgroundColor: string = 'white';

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngAfterViewInit(): void {
    const contentDiv = this.getElement('dialog-content');

    const propriedades = ['height'];
    const headerHeight = this.getHeight('dialog-header', propriedades);
    const customHeaderHeight = this.getHeight('dialog-custom-header', propriedades);
    const footnoteHeight = this.getHeight('dialog-footnote', propriedades);

    const height = headerHeight + customHeaderHeight + footnoteHeight;

    if (contentDiv) {
      contentDiv.style.setProperty('max-height', 'calc(90vh - ' + height + 'px)');
      if (this.fixedHeight !== null)
        contentDiv.style.setProperty('height', 'calc(' + this.fixedHeight + ' - ' + height + 'px)');
    }

    const footnoteDiv = this.getElement('dialog-footnote');
    if (footnoteDiv) footnoteDiv.style.setProperty('background-color', this.footnoteBackgroundColor);
  }

  getHeight(elementID: string, propriedades: string[]): number {
    const div = this.getElement(elementID);
    if (!div)
      return 0;

    const style = window.getComputedStyle(div);
    let height = 0;

    propriedades.forEach((value) => {
      const temp = style.getPropertyValue(value);
      height += parseInt(temp, 10);
    });

    return height;
  }

  private getElement(elementID: string): HTMLElement | null {
    return this.elementRef.nativeElement.querySelector('#' + elementID);
  }
}
